import { useContext, useRef } from 'react';
import * as Consts from '../utils/constants';
import { WebEditorContext } from '../contexts';

export const useTextLibraryAutoComplete = (wait = 50) => {
    const timeout = useRef(null);
    const { editorFileRef } = useContext(WebEditorContext);
    const isEnabled = editorFileRef?.current?.WebEditorSettings?.TextLibraryEnabled;
    const lookForAutoComplete = (input, onAutoComplete, onAutoCompleteIsDetected) => {

        if(!isEnabled) {
            return false;
        }

        const regexInit = new RegExp('^##[^# ]*$', 'i');
        const autoCompleteInit = regexInit.test(input);

        const regexp = new RegExp('^##[^# ]{1,}\\s$', 'i');
        const startsWith = regexp.test(input);
        if (autoCompleteInit) {
            onAutoCompleteIsDetected()
            return true;
        }
        const ends = input.endsWith(' ');
        if (startsWith && ends) {
            startWaitExecute(input, onAutoComplete, onAutoCompleteIsDetected);
            return true;
        }

        if (input == '#' && input.length === 1) {
            onAutoCompleteIsDetected()
            return true;
        }

        if (timeout.current) {
            // console.log('clear')
            clearInterval(timeout.current);
        }

        return false;
    }

    const lookForSearch = (input, onSearchDetected) => {
        
        if(!isEnabled) {
            return false;
        }
        
        console.log('input', input)
        if (input === '### ') {
            onSearchDetected(input);
            return true;
        }

        return false;
    }

    const startWaitExecute = (code, onWaitComplete, onAutoCompleteIsDetected) => {
        onAutoCompleteIsDetected();
        // console.log('startWaitExecute')
        if (timeout.current) {
            // console.log('clear')
            clearInterval(timeout.current);
        }

        timeout.current = setTimeout(() => onWaitComplete(code), wait);
    }

    return {
        isEnabled: isEnabled,
        lookForAutoComplete: (text, onAutoComplete, onAutoCompleteIsDetected) => {
            return lookForAutoComplete(text, onAutoComplete, onAutoCompleteIsDetected);
        },
        lookForSearch: (text, onSearchDetected) => {
            return lookForSearch(text, onSearchDetected);
        }
    }
}